/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.page-documents[_ngcontent-%COMP%]{padding:7px 0 30px}.page-documents[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#3d516f}.page-documents[_ngcontent-%COMP%]   .document-nav[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin:10px 0 25px}.page-documents[_ngcontent-%COMP%]   .document-nav[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{font-size:.75rem;min-width:145px}"];
export { styles as styles };
